import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${API_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

// Add token from localStorage as fallback
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('bunchh_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Auth
export const memberLogin = (email) => api.post('/auth/login', { email });
export const adminVerify = (email, code) => api.post('/auth/admin-verify', { email, code });
export const getMe = () => api.get('/auth/me');
export const logout = () => api.post('/auth/logout');

// Waitlist
export const submitWaitlistPart1 = (data) => api.post('/waitlist/part1', data);
export const submitWaitlistPart2 = (data) => api.post('/waitlist/part2', data);

// Events
export const getPublicEvents = () => api.get('/events');
export const getMemberEvents = () => api.get('/events/member');
export const getEvent = (id) => api.get(`/events/${id}`);

// Bookings
export const createBooking = (data) => api.post('/bookings', data);

// Payments
export const createPaymentOrder = (data) => api.post('/payments/create-order', data);
export const verifyPayment = (data) => api.post('/payments/verify', data);

// Cloudinary
export const getCloudinarySignature = (folder = 'bunchh') => api.get(`/cloudinary/signature?folder=${folder}`);

// Admin
export const getAdminStats = () => api.get('/admin/stats');
export const getAdminEvents = () => api.get('/admin/events');
export const createAdminEvent = (data) => api.post('/admin/events', data);
export const updateAdminEvent = (id, data) => api.put(`/admin/events/${id}`, data);
export const deleteAdminEvent = (id) => api.delete(`/admin/events/${id}`);
export const getAdminWaitlist = () => api.get('/admin/waitlist');
export const getAdminBookings = () => api.get('/admin/bookings');
export const getAdminMembers = () => api.get('/admin/members');
export const bulkUploadMembers = (emails) => api.post('/admin/members/bulk-upload', { emails });

export default api;
